interface TileLayout {
  doubleWidthBasisClass: string;
  gapXClass: string;
  gridColsClass: string;
  normalWidthBasisClass: string;
  paddingRightClass: string;
}

// An array of tile sizes at various breakpoints
// This allows us to centralise the breakpoints across the carousels/zones
const TILE_LAYOUT_CLASSES: TileLayout[] = [
  // 2 tiles
  {
    paddingRightClass: 'pr-3',
    gapXClass: 'gap-x-3',
    normalWidthBasisClass: 'basis-1/2',
    doubleWidthBasisClass: 'basis-1',
    gridColsClass: 'grid-cols-2',
  },
  // 3 tiles
  {
    paddingRightClass: '@[540px]:pr-4',
    gapXClass: '@[540px]:gap-x-4',
    normalWidthBasisClass: '@[540px]:basis-1/3',
    doubleWidthBasisClass: '@[540px]:basis-2/3',
    gridColsClass: '@[540px]:grid-cols-3',
  },
  // 4 tiles
  {
    paddingRightClass: '@[800px]:pr-4',
    gapXClass: '@[800px]:gap-x-4',
    normalWidthBasisClass: '@[800px]:basis-1/4',
    doubleWidthBasisClass: '@[800px]:basis-1/2',
    gridColsClass: '@[800px]:grid-cols-4',
  },
  // 5 tiles
  {
    paddingRightClass: '@[1050px]:pr-6',
    gapXClass: '@[1050px]:gap-x-6',
    normalWidthBasisClass: '@[1050px]:basis-1/5',
    doubleWidthBasisClass: '@[1050px]:basis-2/5',
    gridColsClass: '@[1050px]:grid-cols-5',
  },
  // 6 tiles
  {
    paddingRightClass: '@[1300px]:pr-6',
    gapXClass: '@[1300px]:gap-x-6',
    normalWidthBasisClass: '@[1300px]:basis-1/6',
    doubleWidthBasisClass: '@[1300px]:basis-1/3',
    gridColsClass: '@[1300px]:grid-cols-6',
  },
  // 7 tiles
  {
    paddingRightClass: '@[2200px]:pr-8',
    gapXClass: '@[2200px]:gap-x-8',
    normalWidthBasisClass: '@[2200px]:basis-[14.28%]',
    doubleWidthBasisClass: '@[2200px]:basis-[28.56%]',
    gridColsClass: '@[2200px]:grid-cols-7',
  },
  // 8 tiles
  {
    paddingRightClass: '@[2400px]:pr-8',
    gapXClass: '@[2400px]:gap-x-8',
    normalWidthBasisClass: '@[2400px]:basis-[12.5%]',
    doubleWidthBasisClass: '@[2400px]:basis-[25%]',
    gridColsClass: '@[2400px]:grid-cols-8',
  },
];

export const TILE_LAYOUT_CLASSES_PADDING = TILE_LAYOUT_CLASSES.map(
  (c) => c.paddingRightClass
).join(' ');

export const TILE_LAYOUT_CLASSES_GAP_X = TILE_LAYOUT_CLASSES.map(
  (c) => c.gapXClass
).join(' ');

export const TILE_LAYOUT_CLASSES_NORMAL_WIDTH_BASIS = TILE_LAYOUT_CLASSES.map(
  (c) => c.normalWidthBasisClass
).join(' ');

export const TILE_LAYOUT_CLASSES_DOUBLE_WIDTH_BASIS = TILE_LAYOUT_CLASSES.map(
  (c) => c.doubleWidthBasisClass
).join(' ');

export const TILE_LAYOUT_CLASSES_GRID = TILE_LAYOUT_CLASSES.map(
  (c) => c.gridColsClass
).join(' ');
